import { Component } from '@angular/core';
import { ParameterService } from 'src/app/shared/service/params/param';

@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrl: './public-footer.component.scss'
})
export class PublicFooterComponent {

  constructor(
    private paramService: ParameterService,

  ) {

  }
  scrollToTop(): void {
    // //console.log("vers le haut");

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }



  configMairie: any = {};

  logo: any;
  commune: any;
  contact:any;
  email:any;
  ngOnInit() {

    this.getLogoNomCommune();
  }


  getLogoNomCommune() {
    this.paramService.getParamatrageCommune().subscribe(
      (response: any) => {
         console.log("le logo du webservice", response);
        this.configMairie = response.data
        this.contact = this.configMairie?.contact?.value;
        this.email = this.configMairie?.email?.value;
        this.logo = this.configMairie?.logo?.value;
        this.commune = this.configMairie?.commune?.value;
      },
      (error: any) => {
        // console.log("une erreur est survenu", error);

      }
    )
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = '../../../assets/new-accueil/logo.png';
  }
}
